import React from 'react';

interface Props {
    koma: number,
    tobi: number,
    resolutionAuto: boolean,
    resolution: number,
    onChangeKoma: ((koma: number) => void),
    onChangeTobi: ((tobi: number) => void),
    onChangeResolution: ((resolution: number) => void),
    onChangeResolutionAuto: ((resolutionAuto: boolean) => void),
};

// [5...32]
const komaOptions = Array.from({ length: 28 }, (v, k) => { return 5 + k }).map((v) => {
    return <option value={v} key={v}>{v}</option>
});

// [2...16]
const tobiOptions = Array.from({ length: 15 }, (v, k) => { return 2 + k }).map((v) => {
    return <option value={v} key={v}>{v}</option>
});

const resolutionOptions = Array.from({ length: 50 }, (v, k) => { return 1 + k }).map((v) => {
    return <option value={v} key={v}>{v}</option>
});

function YubinukiBasicSettings(props: Props) {
    function handleChangeKoma(e: React.FormEvent<HTMLSelectElement>) {
        props.onChangeKoma(parseInt(e.currentTarget.value));
    }
    function handleChangeTobi(e: React.FormEvent<HTMLSelectElement>) {
        props.onChangeTobi(parseInt(e.currentTarget.value));
    }
    function handleChangeResolution(e: React.FormEvent<HTMLSelectElement>) {
        props.onChangeResolution(parseInt(e.currentTarget.value));
    }
    function handleChangeResolutionAuto(e: React.FormEvent<HTMLInputElement>) {
        props.onChangeResolutionAuto(e.currentTarget.checked);
    }

    return (
        <div className="basicSettings">
            <form>
                <div className="form-row">
                    <div className="form-group col-sm-6 col-md-4">
                        <label htmlFor="koma">コマ：</label>
                        <select id="koma" className="form-control" value={props.koma} onChange={handleChangeKoma} >
                            {komaOptions}
                        </select>
                    </div>
                    <div className="form-group col-sm-6 col-md-4">
                        <label htmlFor="tobi">トビ：</label>
                        <select id="tobi" className="form-control" value={props.tobi} onChange={handleChangeTobi}>
                            {tobiOptions}
                        </select>
                    </div>
                    <div className="form-group col-sm-12 col-md-4">
                        <label htmlFor="resolution">コマあたりの段数：</label>
                        <div className="form-check form-check-inline ml-2">
                            <input type="checkbox" id="resolutionAuto" name="resolutionAuto" className="form-check-input" checked={props.resolutionAuto} onChange={handleChangeResolutionAuto}/><label htmlFor="resolutionAuto" className="form-check-label">自動計算する</label>
                        </div>
                        <select id="resolution" className="form-control" value={props.resolution} onChange={handleChangeResolution} disabled={props.resolutionAuto}>
                            {resolutionOptions}
                        </select>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default YubinukiBasicSettings;
